export const UPDATE_START_OF_LAST_ITINERARY_SEARCH = 'UPDATE_START_OF_LAST_ITINERARY_SEARCH'

export function startOfLastItinerarySearchReducer(state = "", action) {
    switch (action.type){
        case UPDATE_START_OF_LAST_ITINERARY_SEARCH:
            return action.payload
        default: return state
    }
}